import React, { useState } from "react";
import ReactDOM from "react-dom";
import { close } from "../../react-hooks/svgIcons";
import { ClearAll } from "@usereactify/search";
import { ClearAllButton } from "./ClearAllButton";

interface DrawerProps {
    children: React.ReactNode;
    title: string;
    buttonPrimaryText: string;
    buttonSecondaryText: string;
    clearAllComponent: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({ children, title, buttonPrimaryText }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = (swymDispatch: boolean) => {
        setIsOpen((prevState) => !prevState);

        if (swymDispatch) {
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        }
    };

    const drawerContent = (
        <div className="drawer__container">
            <div
                className={`overlay ${isOpen ? "visible" : ""}`}
                onClick={() => toggleDrawer(true)}
            ></div>
            <div className={`drawer-content ${isOpen ? "show" : ""}`}>
                <div className="drawer__header flex relative">
                    <h4 className="w-full font-san-serif-extended uppercase">{title}</h4>
                    <div
                        className="drawer-close__btn absolute"
                        onClick={() => toggleDrawer(true)}
                    >
                        {close}
                    </div>
                </div>
                <div className="drawer__options">{children}</div>

                {(buttonPrimaryText) &&
                    <div className="drawer__footer flex flex-col gap-3">
                        {buttonPrimaryText &&
                            <button className="button button-primary uppercase" onClick={() => toggleDrawer(true)}>{buttonPrimaryText}</button>
                        }

                        <ClearAll
                            showWhenEmpty={true}
                            render={ClearAllButton}
                        />
                    </div>
                }

            </div>
        </div>
    );

    return (
        <div>
            <div
                className="drawer__btn uppercase"
                onClick={() => toggleDrawer(false)}
            >
                {title}
            </div>
            {ReactDOM.createPortal(
                drawerContent,
                document.getElementById("react-drawer-portal")!
            )}
        </div>
    );
};
